import React from "react";
import { ReactComponent as SearchIcon } from "../icons/search.svg";
// import Chevron from "../icons/chevron.svg";
import FeatherIcon from "feather-icons-react";
import { getFirstTwoChars } from "../../utils";
import { useAppState } from "../../context/appContex";

interface ActionsProps {
  toggleDropDown: () => void;
  isSearch?: boolean;
  openSearch?: () => void;
  isSamll?: boolean;
}

const Actions: React.FC<ActionsProps> = ({
  toggleDropDown,
  isSearch,
  openSearch,
  isSamll,
}) => {
  const { user } = useAppState();

  return (
    <div className='actions'>
      {isSearch && (
        <div onClick={openSearch}>
          <SearchIcon />
        </div>
      )}
      <div
        className='user'
        style={isSamll ? { marginLeft: "15px" } : {}}
        onClick={toggleDropDown}
      >
        {user ? getFirstTwoChars(user) : <FeatherIcon icon='chevron-down' />}
      </div>
      {/* <span style={{ marginLeft: "10px", cursor: "pointer" }} className='lang'>
        EN
      </span> */}
      {/* <Chevron /> */}
    </div>
  );
};

export default Actions;
